import { isReloginOpen } from 'ts-utils/session'

export const SHOW = 'alertSnackbar/SHOW'
export const HIDE = 'alertSnackbar/HIDE'

const initState = {
    show: false,
    anchor: {
        vertical: 'top',
        horizontal: 'center'
    },
    variant: 'warning',  // error, info, success, warning
    message: '',
    actions: [],
    duration: 2500
}

export default (state = initState, action) => {
    const anchor = action.anchor || initState.anchor
    const variant = action.variant || initState.variant
    const duration = action.duration || initState.duration
    const actions = action.actions || initState.actions

    switch(action.type) {
        case SHOW:
            // 로그인이 풀려 실패한 요청의 에러 알림은 띄우지 않는다 (재로그인 모달만)
            if (variant === 'error' && isReloginOpen()) return state

            return {
                ...state,
                show: true,
                variant,
                anchor,
                actions,
                message: action.message,
                duration
            }
        case HIDE:
            return {
                ...state,
                show: false
            }
        default:
            return state
    }
}